import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable({
  providedIn: "root",
})
export class ReporteSancionesPersonasService {
  private API_URL: string;
  constructor(
    private http: HttpClient,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = this.enviromentGlobalService.apiUrl;
  }

  getDataTable(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Reporte/PaginadoReporteSancionesPersonas?PageNumber=${entry.numeroPagina}&PageSize=10`,
        entry
      )
      .pipe(retry(2));
  }

  generarExportarSancionesPersona(entry: any) {
    console.log(entry);
    return this.http
      .post<any>(`${this.API_URL}/Reporte/GenerarExportarReporteSancionesPersonas`, entry, {
        observe: "response",
      })
      .pipe(retry(2));
  }
}
